import axiosService from '../utils/axios';

/**
 * Interface for similarity configuration object
 */
export interface SimilarityConfig {
  NEW_USER_DAYS_THRESHOLD: number;
  SKILL_MATCH_POINTS: number;
  ARTIST_MATCH_POINTS: number;
  GENRE_MATCH_POINTS: number;
  EXACT_LOCATION_MATCH?: number;
  HEADLINE_MATCH_POINTS?: number;
  OPEN_TO_MATCH_POINTS?: number;
  BOOST_BASE_POINTS?: number;
  BOOST_MULTIPLIER?: number;
  ALREADY_LIKED_PENALTY?: number;
}

/**
 * Fetches the current similarity configuration from the backend
 * @returns {Promise<SimilarityConfig>} The similarity configuration object
 */
export const getSimilarityConfig = async (): Promise<SimilarityConfig> => {
    try {
        const { data } = await axiosService.get('/similarity/config');
        return data;
    } catch (error) {
        console.error('Error fetching similarity configuration:', error);
        return {
            // Default values if API call fails
            NEW_USER_DAYS_THRESHOLD: 24,
            SKILL_MATCH_POINTS: 0.3,
            ARTIST_MATCH_POINTS: 0.8,
            GENRE_MATCH_POINTS: 0.5
        };
    }
};
